module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_08-b218ac35c1a2ee739e27a37bf27117b7.svg";